import React from 'react';

export const GridIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25 2.25V8.25H8.25V2.25H2.25ZM6.75 6.75H3.75V3.75H6.75V6.75ZM2.25 9.75V15.75H8.25V9.75H2.25ZM6.75 14.25H3.75V11.25H6.75V14.25ZM9.75 2.25V8.25H15.75V2.25H9.75ZM14.25 6.75H11.25V3.75H14.25V6.75ZM9.75 9.75V15.75H15.75V9.75H9.75ZM14.25 14.25H11.25V11.25H14.25V14.25Z"
      fill="#687587"
    />
  </svg>
);
